export const ItemListDeserializer = items => {
  return items.map(item => {
    return {
      id: item.id,
      name: item.name,
      category: (item.category && item.category.title) || "",
    };
  });
};
